var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--ping-pong", style: _vm.styles },
    [
      _c("div", { staticClass: "spinner-inner", style: _vm.innerStyles }, [
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "board" }, [
      _c("div", { staticClass: "left" }),
      _vm._v(" "),
      _c("div", { staticClass: "right" }),
      _vm._v(" "),
      _c("div", { staticClass: "ball" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }